import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { SurveyIntroComponent } from './survey-intro/survey-intro.component';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { SurveyMainComponent } from './survey-main/survey-main.component';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { TranslateModule } from '@ngx-translate/core';
import { SurveyQuestionnaireService } from './survey-questionnaire.service';
import { SurveyThankYouComponent } from './survey-thank-you/survey-thank-you.component';
import { SurveyCompletedComponent } from './survey-completed/survey-completed.component';
import { SurveyAbandonedComponent } from './survey-abandoned/survey-abandoned.component';
import { SurveyViewComponent } from './survey-view/survey-view.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedDisplayModule } from '@brightside-web/shared/display';
import { SurveyInfoViewComponent } from './survey-info-view/survey-info-view.component';
import { SurveyInfoViewGuard } from './survey-info-view.guard';
import { SurveyGuard } from './survey.guard';
import { authCanActivateGuard } from '@brightside-web/desktop/data-access/core-services';

const routes: Routes = [
  {
    path: 'info-view',
    component: SurveyInfoViewComponent,
    canActivate: [SurveyInfoViewGuard]
  },
  {
    path: ':type',
    component: SurveyMainComponent,
    canActivate: [authCanActivateGuard, SurveyGuard],
    children: [
      { path: 'intro', component: SurveyIntroComponent },
      { path: 'view', component: SurveyViewComponent },
      { path: 'thank-you', component: SurveyThankYouComponent },
      { path: 'completed', component: SurveyCompletedComponent },
      { path: 'abandoned', component: SurveyAbandonedComponent },
    ],
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    BrightsideUiModule,
    MicroUiMoleculeModule,
    ReactiveFormsModule,
    SharedDesktopModule,
    TranslateModule,
    SharedDisplayModule,
  ],
  declarations: [],
  providers: [SurveyInfoViewGuard],
})
export class DesktopFeatureSurveyQuestionnaireModule {}
